import { render, staticRenderFns } from "./CcpPoint .vue?vue&type=template&id=ecc0b166&scoped=true"
import script from "./CcpPoint .vue?vue&type=script&lang=js"
export * from "./CcpPoint .vue?vue&type=script&lang=js"
import style0 from "./CcpPoint .vue?vue&type=style&index=0&id=ecc0b166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc0b166",
  null
  
)

export default component.exports